export const translations = {
  tr: {
    nav: {
      home: 'Ana Sayfa',
      privacy: 'Gizlilik Politikası',
      terms: 'Kullanım Şartları',
      support: 'Destek',
      dataDeletion: 'Veri Silme'
    },
    hero: {
      title: 'Mutfağınızdaki AI Asistanı',
      subtitle: 'Dolabınızdaki malzemelerle en lezzetli tarifleri keşfedin',
      downloadApp: 'Uygulamayı İndir',
      learnMore: 'Daha Fazla Bilgi'
    },
    features: {
      title: 'Neden Chefyz?',
      subtitle: 'Yemek yapmayı kolaylaştıran özellikler',
      feature1: {
        title: 'Şefe Sor',
        desc: 'AI destekli şefimize malzemelerinizi söyleyin, size özel tarifler alsın'
      },
      feature2: {
        title: 'Gelişmiş Arama',
        desc: 'Ülke mutfağı, kategori ve tercihlerinize göre tarif bulun'
      },
      feature3: {
        title: 'Hızlı Mod',
        desc: 'Malzemeleri seçin, anında tarif önerileri alın'
      },
      feature4: {
        title: 'Alışveriş Listesi',
        desc: 'Eksik malzemeleri listeye ekleyin, WhatsApp ile paylaşın'
      },
      feature5: {
        title: 'Çok Dilli Destek',
        desc: '6 farklı dilde tarif ve uygulama deneyimi'
      },
      feature6: {
        title: 'Püf Noktaları',
        desc: 'Her tarif için şefin özel ipuçları ve sırları'
      }
    },
    cta: {
      title: 'Hemen Başlayın',
      subtitle: 'Chefyz ile mutfakta harikalar yaratın',
      button: 'Ücretsiz İndir'
    },
    footer: {
      description: 'AI destekli yemek tarifi asistanınız',
      legal: 'Yasal',
      contact: 'İletişim',
      followUs: 'Bizi Takip Edin',
      downloadApp: 'İndir',
      rights: 'Tüm hakları saklıdır.'
    },
    privacy: {
      title: 'Gizlilik Politikası',
      lastUpdated: 'Son Güncelleme',
      intro: 'Chefyz olarak gizliliğinize önem veriyoruz. Bu politika, uygulamamızı kullandığınızda bilgilerinizi nasıl topladığımızı, kullandığımızı ve koruduğumuzu açıklar.',
      sections: {
        dataCollection: {
          title: 'Toplanan Veriler',
          content: 'Uygulamamız aşağıdaki verileri toplayabilir:\n• Hesap bilgileri (e-posta, ad)\n• Kullanım verileri (tarif aramaları, favoriler)\n• Cihaz bilgileri (cihaz türü, işletim sistemi)\n• Konum bilgileri (yalnızca izin verilirse)'
        },
        dataUsage: {
          title: 'Verilerin Kullanımı',
          content: 'Topladığımız verileri şu amaçlarla kullanırız:\n• Kişiselleştirilmiş tarif önerileri sunmak\n• Uygulama deneyimini iyileştirmek\n• Teknik sorunları çözmek\n• Yasal gereklilikleri yerine getirmek'
        },
        dataSharing: {
          title: 'Veri Paylaşımı',
          content: 'Kişisel verilerinizi üçüncü taraflarla satmıyoruz. Verileriniz yalnızca şu durumlarda paylaşılabilir:\n• Yasal zorunluluk halinde\n• Hizmet sağlayıcılarımızla (Firebase, Google Gemini)\n• Açık izniniz olduğunda'
        },
        aiService: {
          title: 'Yapay Zeka Hizmeti (Google Gemini)',
          content: 'Chefyz, tarif önerileri oluşturmak için Google Gemini AI kullanmaktadır. Şefe Sor özelliğinde girdiğiniz malzeme ve sorular Google\'ın sunucularına iletilmekte ve Google\'ın Gizlilik Politikası\'na tabi olmaktadır (https://policies.google.com/privacy).'
        },
        dataSecurity: {
          title: 'Veri Güvenliği',
          content: 'Verilerinizi korumak için endüstri standardı güvenlik önlemleri kullanıyoruz:\n• SSL/TLS şifreleme\n• Güvenli sunucu altyapısı\n• Düzenli güvenlik denetimleri'
        },
        dataRetention: {
          title: 'Veri Saklama ve Silme',
          content: 'Hesap bilgileriniz ve hesabınızla ilişkili içerikler, hesabınız aktif olduğu sürece hizmeti sunmak amacıyla saklanır. Hesabınızı uygulama içinden sildiğinizde Firebase Authentication hesabınız ve hesabınızla ilişkilendirilebilen uygulama verileri kalıcı olarak silinir. Web sitesi veya e-posta üzerinden doğrulanmış silme talepleri en geç 30 gün içinde tamamlanır. Yapay zeka istek günlükleri en fazla 24 saat; hesapla ilişkilendirilmeyen, kötüye kullanımı önlemeye yönelik cihaz kullanım kayıtları en fazla 30 gün tutulur. Güvenlik, dolandırıcılığı önleme veya yasal yükümlülükler nedeniyle tutulması zorunlu sınırlı kayıtlar yalnızca gerekli süre boyunca saklanır ve ardından silinir veya anonimleştirilir.'
        },
        children: {
          title: 'Çocukların Gizliliği',
          content: 'Uygulamamız 13 yaşın altındaki çocuklara yönelik değildir. Bilerek 13 yaşın altındaki kişilerden kişisel bilgi toplamıyoruz.'
        },
        rights: {
          title: 'Haklarınız',
          content: 'KVKK ve GDPR kapsamında şu haklara sahipsiniz:\n• Verilerinize erişim hakkı\n• Verilerinizi düzeltme hakkı\n• Verilerinizi silme hakkı\n• Veri işlemeye itiraz hakkı\n• Veri taşınabilirliği hakkı'
        },
        cookies: {
          title: 'Çerezler ve İzleme',
          content: 'Uygulamamız, deneyiminizi iyileştirmek için çerezler ve benzer teknolojiler kullanabilir. Reklam hizmetleri için Google AdMob kullanılmaktadır.'
        },
        changes: {
          title: 'Politika Değişiklikleri',
          content: 'Bu gizlilik politikasını zaman zaman güncelleyebiliriz. Önemli değişiklikler hakkında sizi bilgilendireceğiz.'
        },
        contact: {
          title: 'İletişim',
          content: 'Gizlilik ile ilgili sorularınız için bizimle iletişime geçebilirsiniz.'
        }
      }
    },
    terms: {
      title: 'Kullanım Şartları',
      lastUpdated: 'Son Güncelleme',
      intro: 'Chefyz uygulamasını kullanarak aşağıdaki şartları kabul etmiş olursunuz.',
      sections: {
        acceptance: {
          title: 'Şartların Kabulü',
          content: 'Uygulamayı indirerek veya kullanarak bu kullanım şartlarını ve gizlilik politikamızı kabul etmiş olursunuz.'
        },
        service: {
          title: 'Hizmet Tanımı',
          content: 'Chefyz, yapay zeka destekli bir yemek tarifi asistanıdır. Uygulama:\n• Malzemelerinize göre tarif önerileri sunar\n• Farklı mutfaklardan tarifler içerir\n• Alışveriş listesi oluşturmanıza yardımcı olur'
        },
        account: {
          title: 'Hesap Oluşturma',
          content: 'Bazı özellikler için hesap oluşturmanız gerekebilir. Hesap bilgilerinizin doğruluğundan ve güvenliğinden siz sorumlusunuz.'
        },
        usage: {
          title: 'Kabul Edilebilir Kullanım',
          content: 'Uygulamayı kullanırken şunları yapmamayı kabul edersiniz:\n• Yasadışı amaçlarla kullanmak\n• Sistemlerimize zarar vermek\n• Diğer kullanıcıları rahatsız etmek\n• Uygulamayı tersine mühendislik yapmak'
        },
        subscription: {
          title: 'Premium Abonelik',
          content: 'Premium özelliklere erişim için ücretli abonelik sunuyoruz. Abonelik şartları:\n• Otomatik yenileme yapılır\n• İptal işlemi mağaza üzerinden yapılır\n• İade politikası mağaza kurallarına tabidir'
        },
        content: {
          title: 'İçerik ve Fikri Mülkiyet',
          content: 'Uygulamadaki tüm içerik, tasarım ve özellikler Chefyz\'a aittir. İzinsiz kopyalama veya dağıtım yasaktır.'
        },
        disclaimer: {
          title: 'Sorumluluk Reddi',
          content: 'Tarifler yalnızca bilgilendirme amaçlıdır. Alerji ve sağlık durumlarınızı göz önünde bulundurun. Chefyz, tarif kullanımından doğacak zararlardan sorumlu değildir.'
        },
        termination: {
          title: 'Hesap Sonlandırma',
          content: 'Şartları ihlal etmeniz durumunda hesabınızı askıya alabilir veya sonlandırabiliriz.'
        },
        changes: {
          title: 'Şart Değişiklikleri',
          content: 'Bu şartları önceden haber vererek değiştirebiliriz. Değişikliklerden sonra uygulamayı kullanmaya devam etmeniz, yeni şartları kabul ettiğiniz anlamına gelir.'
        },
        governing: {
          title: 'Uygulanacak Hukuk',
          content: 'Bu şartlar Türkiye Cumhuriyeti yasalarına tabidir.'
        }
      }
    },
    support: {
      title: 'Destek',
      subtitle: 'Size nasıl yardımcı olabiliriz?',
      faq: {
        title: 'Sık Sorulan Sorular',
        q1: 'Uygulama ücretsiz mi?',
        a1: 'Evet, temel özellikler ücretsizdir. Sınırsız erişim için Premium abonelik sunuyoruz.',
        q2: 'Premium aboneliği nasıl iptal ederim?',
        a2: 'Aboneliğinizi App Store veya Google Play Store üzerinden iptal edebilirsiniz.',
        q3: 'Verilerimi nasıl silerim?',
        a3: 'Veri silme talebi için destek sayfamızdaki formu kullanabilir veya bize e-posta gönderebilirsiniz.',
        q4: 'Hangi dilleri destekliyorsunuz?',
        a4: 'Türkçe, İngilizce, Almanca, Fransızca, İspanyolca ve İtalyanca dillerini destekliyoruz.'
      },
      contact: {
        title: 'Bize Ulaşın',
        name: 'Adınız',
        email: 'E-posta Adresiniz',
        subject: 'Konu',
        message: 'Mesajınız',
        send: 'Gönder',
        success: 'Mesajınız başarıyla gönderildi!',
        subjects: {
          general: 'Genel Soru',
          bug: 'Hata Bildirimi',
          feature: 'Özellik Önerisi',
          account: 'Hesap Sorunu',
          other: 'Diğer'
        }
      }
    },
    dataDeletion: {
      title: 'Veri Silme Talebi',
      subtitle: 'Kişisel verilerinizin silinmesini talep edin',
      intro: 'KVKK ve GDPR kapsamında, kişisel verilerinizin silinmesini talep etme hakkınız vardır.',
      process: {
        title: 'Silme Süreci',
        step1: 'Aşağıdaki formu doldurun',
        step2: 'Talebiniz 30 gün içinde işleme alınır',
        step3: 'Silme işlemi tamamlandığında e-posta ile bilgilendirilirsiniz'
      },
      what: {
        title: 'Hangi Veriler Silinir?',
        content: 'Talebiniz üzerine şunlar silinir:\n• Hesap bilgileriniz\n• Favori tarifleriniz\n• Arama geçmişiniz\n• Sohbet geçmişiniz\n• Alışveriş listeleriniz'
      },
      form: {
        email: 'Kayıtlı E-posta Adresiniz',
        reason: 'Silme Nedeni (İsteğe Bağlı)',
        confirm: 'Verilerimin kalıcı olarak silineceğini anlıyorum',
        submit: 'Silme Talebi Gönder',
        success: 'Talebiniz alındı. 30 gün içinde işleme alınacaktır.'
      },
      note: 'Not: Silme işlemi geri alınamaz. İşlem tamamlandıktan sonra verilerinize erişilemez.'
    }
  },
  en: {
    nav: {
      home: 'Home',
      privacy: 'Privacy Policy',
      terms: 'Terms of Service',
      support: 'Support',
      dataDeletion: 'Data Deletion'
    },
    hero: {
      title: 'Your AI Kitchen Assistant',
      subtitle: 'Discover delicious recipes based on ingredients in your fridge',
      downloadApp: 'Download App',
      learnMore: 'Learn More'
    },
    features: {
      title: 'Why Chefyz?',
      subtitle: 'Features that make cooking easier',
      feature1: {
        title: 'Ask the Chef',
        desc: 'Tell our AI chef your ingredients and get personalized recipes'
      },
      feature2: {
        title: 'Advanced Search',
        desc: 'Find recipes by cuisine, category, and preferences'
      },
      feature3: {
        title: 'Quick Mode',
        desc: 'Select ingredients and get instant recipe suggestions'
      },
      feature4: {
        title: 'Shopping List',
        desc: 'Add missing ingredients to your list and share via WhatsApp'
      },
      feature5: {
        title: 'Multi-language Support',
        desc: 'Recipe and app experience in 6 different languages'
      },
      feature6: {
        title: "Chef's Tips",
        desc: "Special tips and secrets from the chef for every recipe"
      }
    },
    cta: {
      title: 'Get Started Today',
      subtitle: 'Create wonders in the kitchen with Chefyz',
      button: 'Download Free'
    },
    footer: {
      description: 'Your AI-powered recipe assistant',
      legal: 'Legal',
      contact: 'Contact',
      followUs: 'Follow Us',
      downloadApp: 'Download',
      rights: 'All rights reserved.'
    },
    privacy: {
      title: 'Privacy Policy',
      lastUpdated: 'Last Updated',
      intro: 'At Chefyz, we value your privacy. This policy explains how we collect, use, and protect your information when you use our app.',
      sections: {
        dataCollection: {
          title: 'Data We Collect',
          content: 'Our app may collect the following data:\n• Account information (email, name)\n• Usage data (recipe searches, favorites)\n• Device information (device type, OS)\n• Location data (only with permission)'
        },
        dataUsage: {
          title: 'How We Use Data',
          content: 'We use collected data to:\n• Provide personalized recipe recommendations\n• Improve app experience\n• Resolve technical issues\n• Meet legal requirements'
        },
        dataSharing: {
          title: 'Data Sharing',
          content: 'We do not sell your personal data to third parties. Your data may only be shared:\n• When legally required\n• With our service providers (Firebase, Google Gemini)\n• With your explicit consent'
        },
        aiService: {
          title: 'AI Service (Google Gemini)',
          content: 'Chefyz uses Google Gemini AI to generate recipe suggestions. Ingredients and queries you enter in the Ask the Chef feature are sent to Google\'s servers and are subject to Google\'s Privacy Policy (https://policies.google.com/privacy).'
        },
        dataSecurity: {
          title: 'Data Security',
          content: 'We use industry-standard security measures to protect your data:\n• SSL/TLS encryption\n• Secure server infrastructure\n• Regular security audits'
        },
        dataRetention: {
          title: 'Data Retention and Deletion',
          content: 'Account information and account-linked content are retained while your account is active so we can provide the service. When you delete your account in the app, your Firebase Authentication account and app data that can be linked to your account are permanently deleted. Verified deletion requests submitted through the website or by email are completed within 30 days. AI request logs are retained for no more than 24 hours, and account-independent device usage records used to prevent abuse are retained for no more than 30 days. Limited records that must be retained for security, fraud prevention, or legal compliance are kept only for the required period and are then deleted or anonymized.'
        },
        children: {
          title: "Children's Privacy",
          content: 'Our app is not intended for children under 13. We do not knowingly collect personal information from children under 13.'
        },
        rights: {
          title: 'Your Rights',
          content: 'Under GDPR and similar regulations, you have:\n• Right to access your data\n• Right to correct your data\n• Right to delete your data\n• Right to object to processing\n• Right to data portability'
        },
        cookies: {
          title: 'Cookies and Tracking',
          content: 'Our app may use cookies and similar technologies to improve your experience. Google AdMob is used for advertising services.'
        },
        changes: {
          title: 'Policy Changes',
          content: 'We may update this privacy policy from time to time. We will notify you of significant changes.'
        },
        contact: {
          title: 'Contact',
          content: 'For privacy-related questions, please contact us.'
        }
      }
    },
    terms: {
      title: 'Terms of Service',
      lastUpdated: 'Last Updated',
      intro: 'By using the Chefyz app, you agree to the following terms.',
      sections: {
        acceptance: {
          title: 'Acceptance of Terms',
          content: 'By downloading or using the app, you agree to these terms of service and our privacy policy.'
        },
        service: {
          title: 'Service Description',
          content: 'Chefyz is an AI-powered recipe assistant. The app:\n• Provides recipe suggestions based on your ingredients\n• Contains recipes from different cuisines\n• Helps you create shopping lists'
        },
        account: {
          title: 'Account Creation',
          content: 'Some features may require account creation. You are responsible for the accuracy and security of your account information.'
        },
        usage: {
          title: 'Acceptable Use',
          content: 'When using the app, you agree not to:\n• Use it for illegal purposes\n• Harm our systems\n• Harass other users\n• Reverse engineer the app'
        },
        subscription: {
          title: 'Premium Subscription',
          content: 'We offer paid subscriptions for premium features. Subscription terms:\n• Auto-renewal applies\n• Cancellation is done through the store\n• Refund policy follows store rules'
        },
        content: {
          title: 'Content and Intellectual Property',
          content: 'All content, design, and features in the app belong to Chefyz. Unauthorized copying or distribution is prohibited.'
        },
        disclaimer: {
          title: 'Disclaimer',
          content: 'Recipes are for informational purposes only. Consider your allergies and health conditions. Chefyz is not responsible for damages from recipe use.'
        },
        termination: {
          title: 'Account Termination',
          content: 'We may suspend or terminate your account if you violate these terms.'
        },
        changes: {
          title: 'Changes to Terms',
          content: 'We may change these terms with prior notice. Continued use after changes means acceptance of new terms.'
        },
        governing: {
          title: 'Governing Law',
          content: 'These terms are governed by the laws of the Republic of Turkey.'
        }
      }
    },
    support: {
      title: 'Support',
      subtitle: 'How can we help you?',
      faq: {
        title: 'Frequently Asked Questions',
        q1: 'Is the app free?',
        a1: 'Yes, basic features are free. We offer Premium subscription for unlimited access.',
        q2: 'How do I cancel Premium subscription?',
        a2: 'You can cancel your subscription through App Store or Google Play Store.',
        q3: 'How do I delete my data?',
        a3: 'You can use the form on our support page or email us for data deletion request.',
        q4: 'Which languages do you support?',
        a4: 'We support Turkish, English, German, French, Spanish, and Italian.'
      },
      contact: {
        title: 'Contact Us',
        name: 'Your Name',
        email: 'Your Email',
        subject: 'Subject',
        message: 'Your Message',
        send: 'Send',
        success: 'Your message has been sent successfully!',
        subjects: {
          general: 'General Question',
          bug: 'Bug Report',
          feature: 'Feature Request',
          account: 'Account Issue',
          other: 'Other'
        }
      }
    },
    dataDeletion: {
      title: 'Data Deletion Request',
      subtitle: 'Request deletion of your personal data',
      intro: 'Under GDPR and similar regulations, you have the right to request deletion of your personal data.',
      process: {
        title: 'Deletion Process',
        step1: 'Fill out the form below',
        step2: 'Your request will be processed within 30 days',
        step3: 'You will be notified via email when deletion is complete'
      },
      what: {
        title: 'What Data Gets Deleted?',
        content: 'Upon your request, the following will be deleted:\n• Your account information\n• Your favorite recipes\n• Your search history\n• Your chat history\n• Your shopping lists'
      },
      form: {
        email: 'Your Registered Email Address',
        reason: 'Reason for Deletion (Optional)',
        confirm: 'I understand my data will be permanently deleted',
        submit: 'Submit Deletion Request',
        success: 'Your request has been received. It will be processed within 30 days.'
      },
      note: 'Note: Deletion is irreversible. Your data cannot be accessed after the process is complete.'
    }
  },
  de: {
    nav: {
      home: 'Startseite',
      privacy: 'Datenschutz',
      terms: 'Nutzungsbedingungen',
      support: 'Support',
      dataDeletion: 'Datenlöschung'
    },
    hero: {
      title: 'Ihr KI-Küchenassistent',
      subtitle: 'Entdecken Sie köstliche Rezepte basierend auf Ihren Zutaten',
      downloadApp: 'App herunterladen',
      learnMore: 'Mehr erfahren'
    },
    features: {
      title: 'Warum Chefyz?',
      subtitle: 'Funktionen, die das Kochen erleichtern',
      feature1: { title: 'Frag den Chef', desc: 'Nennen Sie unserem KI-Koch Ihre Zutaten' },
      feature2: { title: 'Erweiterte Suche', desc: 'Finden Sie Rezepte nach Küche und Kategorie' },
      feature3: { title: 'Schnellmodus', desc: 'Wählen Sie Zutaten, erhalten Sie sofort Rezepte' },
      feature4: { title: 'Einkaufsliste', desc: 'Teilen Sie fehlende Zutaten per WhatsApp' },
      feature5: { title: 'Mehrsprachig', desc: 'App-Erlebnis in 6 Sprachen' },
      feature6: { title: 'Chef-Tipps', desc: 'Spezielle Tipps für jedes Rezept' }
    },
    cta: { title: 'Jetzt starten', subtitle: 'Zaubern Sie in der Küche mit Chefyz', button: 'Kostenlos herunterladen' },
    footer: { description: 'Ihr KI-Rezeptassistent', legal: 'Rechtliches', contact: 'Kontakt', followUs: 'Folgen Sie uns', downloadApp: 'Herunterladen', rights: 'Alle Rechte vorbehalten.' },
    privacy: {
      title: 'Datenschutzrichtlinie',
      lastUpdated: 'Letzte Aktualisierung',
      intro: 'Bei Chefyz schätzen wir Ihre Privatsphäre. Diese Richtlinie erklärt, wie wir Ihre Daten sammeln und schützen.',
      sections: {
        dataCollection: { title: 'Datenerfassung', content: 'Unsere App kann folgende Daten erfassen:\n• Kontoinformationen\n• Nutzungsdaten\n• Geräteinformationen\n• Standortdaten (nur mit Erlaubnis)' },
        dataUsage: { title: 'Datennutzung', content: 'Wir nutzen Daten für:\n• Personalisierte Empfehlungen\n• App-Verbesserung\n• Technische Problemlösung' },
        dataSharing: { title: 'Datenweitergabe', content: 'Wir verkaufen Ihre Daten nicht. Weitergabe nur:\n• Bei rechtlicher Pflicht\n• An Dienstleister (Firebase, Google Gemini)\n• Mit Ihrer Zustimmung' },
        aiService: { title: 'KI-Dienst (Google Gemini)', content: 'Chefyz verwendet Google Gemini AI für Rezeptvorschläge. Ihre Eingaben werden an Google-Server übermittelt und unterliegen der Google-Datenschutzrichtlinie (https://policies.google.com/privacy).' },
        dataSecurity: { title: 'Datensicherheit', content: 'Wir verwenden branchenübliche Sicherheitsmaßnahmen.' },
        dataRetention: { title: 'Datenspeicherung und Löschung', content: 'Kontoinformationen und kontobezogene Inhalte werden gespeichert, solange Ihr Konto aktiv ist, um den Dienst bereitzustellen. Wenn Sie Ihr Konto in der App löschen, werden Ihr Firebase-Authentication-Konto und alle Ihrem Konto zuordenbaren App-Daten dauerhaft gelöscht. Verifizierte Löschanfragen über die Website oder per E-Mail werden innerhalb von 30 Tagen abgeschlossen. KI-Anfrageprotokolle werden höchstens 24 Stunden und kontounabhängige Gerätenutzungsdaten zur Missbrauchsprävention höchstens 30 Tage gespeichert. Gesetzlich oder aus Sicherheitsgründen erforderliche begrenzte Datensätze werden nur für die notwendige Dauer aufbewahrt und anschließend gelöscht oder anonymisiert.' },
        children: { title: 'Kinderschutz', content: 'Unsere App ist nicht für Kinder unter 13 Jahren bestimmt.' },
        rights: { title: 'Ihre Rechte', content: 'Nach DSGVO haben Sie:\n• Auskunftsrecht\n• Berichtigungsrecht\n• Löschungsrecht\n• Widerspruchsrecht' },
        cookies: { title: 'Cookies', content: 'Wir verwenden Cookies. Google AdMob für Werbung.' },
        changes: { title: 'Änderungen', content: 'Wir können diese Richtlinie aktualisieren.' },
        contact: { title: 'Kontakt', content: 'Bei Fragen kontaktieren Sie uns.' }
      }
    },
    terms: {
      title: 'Nutzungsbedingungen',
      lastUpdated: 'Letzte Aktualisierung',
      intro: 'Durch die Nutzung von Chefyz akzeptieren Sie diese Bedingungen.',
      sections: {
        acceptance: { title: 'Annahme', content: 'Mit dem Download akzeptieren Sie diese Bedingungen.' },
        service: { title: 'Servicebeschreibung', content: 'Chefyz ist ein KI-Rezeptassistent.' },
        account: { title: 'Kontoerstellung', content: 'Sie sind für Ihre Kontosicherheit verantwortlich.' },
        usage: { title: 'Nutzungsregeln', content: 'Keine illegale Nutzung oder Systemschädigung.' },
        subscription: { title: 'Premium', content: 'Auto-Verlängerung. Kündigung über Store.' },
        content: { title: 'Geistiges Eigentum', content: 'Alle Inhalte gehören Chefyz.' },
        disclaimer: { title: 'Haftungsausschluss', content: 'Rezepte nur zur Information.' },
        termination: { title: 'Kündigung', content: 'Bei Verstoß können wir Ihr Konto sperren.' },
        changes: { title: 'Änderungen', content: 'Wir können Bedingungen ändern.' },
        governing: { title: 'Geltendes Recht', content: 'Es gilt türkisches Recht.' }
      }
    },
    support: {
      title: 'Support',
      subtitle: 'Wie können wir helfen?',
      faq: {
        title: 'Häufige Fragen',
        q1: 'Ist die App kostenlos?', a1: 'Ja, Grundfunktionen sind kostenlos.',
        q2: 'Wie kündige ich Premium?', a2: 'Über App Store oder Google Play.',
        q3: 'Wie lösche ich meine Daten?', a3: 'Nutzen Sie das Formular oder E-Mail.',
        q4: 'Welche Sprachen werden unterstützt?', a4: 'TR, EN, DE, FR, ES, IT.'
      },
      contact: { title: 'Kontakt', name: 'Ihr Name', email: 'Ihre E-Mail', subject: 'Betreff', message: 'Nachricht', send: 'Senden', success: 'Erfolgreich gesendet!', subjects: { general: 'Allgemein', bug: 'Fehler', feature: 'Vorschlag', account: 'Konto', other: 'Sonstiges' } }
    },
    dataDeletion: {
      title: 'Datenlöschung',
      subtitle: 'Beantragen Sie die Löschung Ihrer Daten',
      intro: 'Nach DSGVO haben Sie das Recht auf Datenlöschung.',
      process: { title: 'Prozess', step1: 'Formular ausfüllen', step2: 'Bearbeitung in 30 Tagen', step3: 'E-Mail-Benachrichtigung' },
      what: { title: 'Was wird gelöscht?', content: '• Kontoinformationen\n• Favoriten\n• Suchverlauf\n• Chat-Verlauf\n• Einkaufslisten' },
      form: { email: 'Registrierte E-Mail', reason: 'Grund (optional)', confirm: 'Ich verstehe, dass meine Daten dauerhaft gelöscht werden', submit: 'Löschung beantragen', success: 'Anfrage erhalten.' },
      note: 'Hinweis: Die Löschung ist unwiderruflich.'
    }
  },
  fr: {
    nav: { home: 'Accueil', privacy: 'Confidentialité', terms: 'Conditions', support: 'Support', dataDeletion: 'Suppression' },
    hero: { title: 'Votre Assistant Cuisine IA', subtitle: 'Découvrez des recettes délicieuses', downloadApp: 'Télécharger', learnMore: 'En savoir plus' },
    features: {
      title: 'Pourquoi Chefyz?',
      subtitle: 'Des fonctionnalités qui facilitent la cuisine',
      feature1: { title: 'Demandez au Chef', desc: 'Dites vos ingrédients à notre chef IA' },
      feature2: { title: 'Recherche Avancée', desc: 'Trouvez des recettes par cuisine et catégorie' },
      feature3: { title: 'Mode Rapide', desc: 'Sélectionnez des ingrédients, obtenez des recettes' },
      feature4: { title: 'Liste de Courses', desc: 'Partagez via WhatsApp' },
      feature5: { title: 'Multilingue', desc: 'Expérience en 6 langues' },
      feature6: { title: 'Conseils du Chef', desc: 'Astuces spéciales pour chaque recette' }
    },
    cta: { title: 'Commencez', subtitle: 'Créez des merveilles avec Chefyz', button: 'Télécharger Gratuit' },
    footer: { description: 'Votre assistant recettes IA', legal: 'Légal', contact: 'Contact', followUs: 'Suivez-nous', downloadApp: 'Télécharger', rights: 'Tous droits réservés.' },
    privacy: {
      title: 'Politique de Confidentialité', lastUpdated: 'Dernière mise à jour',
      intro: 'Chez Chefyz, nous respectons votre vie privée.',
      sections: {
        dataCollection: { title: 'Données Collectées', content: '• Informations de compte\n• Données d\'utilisation\n• Informations appareil' },
        dataUsage: { title: 'Utilisation', content: '• Recommandations personnalisées\n• Amélioration de l\'app' },
        dataSharing: { title: 'Partage', content: 'Nous ne vendons pas vos données. Partagé avec nos fournisseurs (Firebase, Google Gemini) uniquement si nécessaire.' },
        aiService: { title: 'Service IA (Google Gemini)', content: 'Chefyz utilise Google Gemini IA pour générer des suggestions de recettes. Vos saisies sont envoyées aux serveurs de Google et soumises à la politique de confidentialité de Google (https://policies.google.com/privacy).' },
        dataSecurity: { title: 'Sécurité', content: 'Mesures de sécurité standard.' },
        dataRetention: { title: 'Conservation et suppression des données', content: 'Les informations du compte et le contenu associé sont conservés tant que votre compte est actif afin de fournir le service. Lorsque vous supprimez votre compte dans l’application, votre compte Firebase Authentication et les données de l’application pouvant être associées à votre compte sont définitivement supprimés. Les demandes de suppression vérifiées envoyées via le site ou par e-mail sont traitées sous 30 jours. Les journaux de requêtes IA sont conservés au maximum 24 heures et les données d’utilisation de l’appareil non liées au compte, utilisées contre les abus, au maximum 30 jours. Les données limitées requises pour la sécurité ou la loi ne sont conservées que pendant la durée nécessaire, puis supprimées ou anonymisées.' },
        children: { title: 'Enfants', content: 'Non destiné aux moins de 13 ans.' },
        rights: { title: 'Vos Droits', content: 'Selon le RGPD: accès, rectification, suppression.' },
        cookies: { title: 'Cookies', content: 'Nous utilisons des cookies.' },
        changes: { title: 'Modifications', content: 'Nous pouvons mettre à jour cette politique.' },
        contact: { title: 'Contact', content: 'Contactez-nous pour toute question.' }
      }
    },
    terms: {
      title: 'Conditions d\'Utilisation', lastUpdated: 'Dernière mise à jour',
      intro: 'En utilisant Chefyz, vous acceptez ces conditions.',
      sections: {
        acceptance: { title: 'Acceptation', content: 'En téléchargeant, vous acceptez ces conditions.' },
        service: { title: 'Service', content: 'Chefyz est un assistant recettes IA.' },
        account: { title: 'Compte', content: 'Vous êtes responsable de votre compte.' },
        usage: { title: 'Utilisation', content: 'Pas d\'utilisation illégale.' },
        subscription: { title: 'Premium', content: 'Renouvellement automatique.' },
        content: { title: 'Propriété', content: 'Tout le contenu appartient à Chefyz.' },
        disclaimer: { title: 'Avertissement', content: 'Recettes à titre informatif.' },
        termination: { title: 'Résiliation', content: 'Nous pouvons suspendre votre compte.' },
        changes: { title: 'Modifications', content: 'Nous pouvons modifier ces conditions.' },
        governing: { title: 'Loi', content: 'Loi turque applicable.' }
      }
    },
    support: {
      title: 'Support', subtitle: 'Comment pouvons-nous vous aider?',
      faq: { title: 'FAQ', q1: 'L\'app est-elle gratuite?', a1: 'Oui, fonctions de base gratuites.', q2: 'Comment annuler Premium?', a2: 'Via App Store ou Google Play.', q3: 'Comment supprimer mes données?', a3: 'Utilisez le formulaire.', q4: 'Quelles langues?', a4: 'TR, EN, DE, FR, ES, IT.' },
      contact: { title: 'Contact', name: 'Nom', email: 'Email', subject: 'Sujet', message: 'Message', send: 'Envoyer', success: 'Envoyé!', subjects: { general: 'Général', bug: 'Bug', feature: 'Suggestion', account: 'Compte', other: 'Autre' } }
    },
    dataDeletion: {
      title: 'Suppression des Données', subtitle: 'Demandez la suppression',
      intro: 'Selon le RGPD, vous pouvez demander la suppression.',
      process: { title: 'Processus', step1: 'Remplir le formulaire', step2: 'Traitement en 30 jours', step3: 'Notification par email' },
      what: { title: 'Données supprimées', content: '• Compte\n• Favoris\n• Historique' },
      form: { email: 'Email enregistré', reason: 'Raison (optionnel)', confirm: 'Je comprends que mes données seront supprimées', submit: 'Demander', success: 'Demande reçue.' },
      note: 'La suppression est irréversible.'
    }
  },
  es: {
    nav: { home: 'Inicio', privacy: 'Privacidad', terms: 'Términos', support: 'Soporte', dataDeletion: 'Eliminar Datos' },
    hero: { title: 'Tu Asistente de Cocina IA', subtitle: 'Descubre recetas deliciosas', downloadApp: 'Descargar', learnMore: 'Más Info' },
    features: {
      title: '¿Por qué Chefyz?',
      subtitle: 'Funciones que facilitan cocinar',
      feature1: { title: 'Pregunta al Chef', desc: 'Dile tus ingredientes a nuestro chef IA' },
      feature2: { title: 'Búsqueda Avanzada', desc: 'Encuentra recetas por cocina y categoría' },
      feature3: { title: 'Modo Rápido', desc: 'Selecciona ingredientes, obtén recetas' },
      feature4: { title: 'Lista de Compras', desc: 'Comparte por WhatsApp' },
      feature5: { title: 'Multiidioma', desc: 'Experiencia en 6 idiomas' },
      feature6: { title: 'Tips del Chef', desc: 'Consejos especiales para cada receta' }
    },
    cta: { title: 'Empieza Hoy', subtitle: 'Crea maravillas con Chefyz', button: 'Descargar Gratis' },
    footer: { description: 'Tu asistente de recetas IA', legal: 'Legal', contact: 'Contacto', followUs: 'Síguenos', downloadApp: 'Descargar', rights: 'Todos los derechos reservados.' },
    privacy: {
      title: 'Política de Privacidad', lastUpdated: 'Última actualización',
      intro: 'En Chefyz valoramos tu privacidad.',
      sections: {
        dataCollection: { title: 'Datos Recopilados', content: '• Información de cuenta\n• Datos de uso\n• Información del dispositivo' },
        dataUsage: { title: 'Uso de Datos', content: '• Recomendaciones personalizadas\n• Mejorar la app' },
        dataSharing: { title: 'Compartir', content: 'No vendemos tus datos. Compartimos con proveedores (Firebase, Google Gemini) solo cuando sea necesario.' },
        aiService: { title: 'Servicio IA (Google Gemini)', content: 'Chefyz usa Google Gemini IA para generar sugerencias de recetas. Tus entradas se envían a los servidores de Google y están sujetas a la política de privacidad de Google (https://policies.google.com/privacy).' },
        dataSecurity: { title: 'Seguridad', content: 'Medidas de seguridad estándar.' },
        dataRetention: { title: 'Conservación y eliminación de datos', content: 'La información de la cuenta y el contenido vinculado se conservan mientras la cuenta esté activa para prestar el servicio. Cuando eliminas tu cuenta desde la aplicación, tu cuenta de Firebase Authentication y los datos de la aplicación que puedan vincularse a ella se eliminan permanentemente. Las solicitudes de eliminación verificadas enviadas por el sitio web o por correo electrónico se completan en un plazo de 30 días. Los registros de solicitudes de IA se conservan como máximo 24 horas y los registros de uso del dispositivo no vinculados a la cuenta, utilizados para prevenir abusos, como máximo 30 días. Los registros limitados exigidos por motivos legales o de seguridad se conservan solo durante el tiempo necesario y después se eliminan o anonimizan.' },
        children: { title: 'Niños', content: 'No para menores de 13 años.' },
        rights: { title: 'Tus Derechos', content: 'Según RGPD: acceso, rectificación, eliminación.' },
        cookies: { title: 'Cookies', content: 'Usamos cookies.' },
        changes: { title: 'Cambios', content: 'Podemos actualizar esta política.' },
        contact: { title: 'Contacto', content: 'Contáctanos para preguntas.' }
      }
    },
    terms: {
      title: 'Términos de Servicio', lastUpdated: 'Última actualización',
      intro: 'Al usar Chefyz, aceptas estos términos.',
      sections: {
        acceptance: { title: 'Aceptación', content: 'Al descargar, aceptas estos términos.' },
        service: { title: 'Servicio', content: 'Chefyz es un asistente de recetas IA.' },
        account: { title: 'Cuenta', content: 'Eres responsable de tu cuenta.' },
        usage: { title: 'Uso', content: 'Sin uso ilegal.' },
        subscription: { title: 'Premium', content: 'Renovación automática.' },
        content: { title: 'Propiedad', content: 'Todo el contenido pertenece a Chefyz.' },
        disclaimer: { title: 'Descargo', content: 'Recetas solo informativas.' },
        termination: { title: 'Terminación', content: 'Podemos suspender tu cuenta.' },
        changes: { title: 'Cambios', content: 'Podemos cambiar estos términos.' },
        governing: { title: 'Ley', content: 'Ley turca aplicable.' }
      }
    },
    support: {
      title: 'Soporte', subtitle: '¿Cómo podemos ayudarte?',
      faq: { title: 'FAQ', q1: '¿Es gratis?', a1: 'Sí, funciones básicas gratis.', q2: '¿Cómo cancelo Premium?', a2: 'Via App Store o Google Play.', q3: '¿Cómo elimino mis datos?', a3: 'Usa el formulario.', q4: '¿Qué idiomas?', a4: 'TR, EN, DE, FR, ES, IT.' },
      contact: { title: 'Contacto', name: 'Nombre', email: 'Email', subject: 'Asunto', message: 'Mensaje', send: 'Enviar', success: '¡Enviado!', subjects: { general: 'General', bug: 'Error', feature: 'Sugerencia', account: 'Cuenta', other: 'Otro' } }
    },
    dataDeletion: {
      title: 'Eliminar Datos', subtitle: 'Solicita la eliminación',
      intro: 'Según RGPD, puedes solicitar eliminación.',
      process: { title: 'Proceso', step1: 'Completa el formulario', step2: 'Procesamiento en 30 días', step3: 'Notificación por email' },
      what: { title: 'Datos eliminados', content: '• Cuenta\n• Favoritos\n• Historial' },
      form: { email: 'Email registrado', reason: 'Razón (opcional)', confirm: 'Entiendo que mis datos serán eliminados', submit: 'Solicitar', success: 'Solicitud recibida.' },
      note: 'La eliminación es irreversible.'
    }
  },
  it: {
    nav: { home: 'Home', privacy: 'Privacy', terms: 'Termini', support: 'Supporto', dataDeletion: 'Elimina Dati' },
    hero: { title: 'Il Tuo Assistente Cucina IA', subtitle: 'Scopri ricette deliziose', downloadApp: 'Scarica', learnMore: 'Scopri di più' },
    features: {
      title: 'Perché Chefyz?',
      subtitle: 'Funzionalità che facilitano la cucina',
      feature1: { title: 'Chiedi allo Chef', desc: 'Dicci i tuoi ingredienti' },
      feature2: { title: 'Ricerca Avanzata', desc: 'Trova ricette per cucina e categoria' },
      feature3: { title: 'Modalità Veloce', desc: 'Seleziona ingredienti, ottieni ricette' },
      feature4: { title: 'Lista Spesa', desc: 'Condividi via WhatsApp' },
      feature5: { title: 'Multilingue', desc: 'Esperienza in 6 lingue' },
      feature6: { title: 'Consigli Chef', desc: 'Suggerimenti speciali per ogni ricetta' }
    },
    cta: { title: 'Inizia Oggi', subtitle: 'Crea meraviglie con Chefyz', button: 'Scarica Gratis' },
    footer: { description: 'Il tuo assistente ricette IA', legal: 'Legale', contact: 'Contatto', followUs: 'Seguici', downloadApp: 'Scarica', rights: 'Tutti i diritti riservati.' },
    privacy: {
      title: 'Privacy Policy', lastUpdated: 'Ultimo aggiornamento',
      intro: 'In Chefyz rispettiamo la tua privacy.',
      sections: {
        dataCollection: { title: 'Dati Raccolti', content: '• Info account\n• Dati utilizzo\n• Info dispositivo' },
        dataUsage: { title: 'Uso Dati', content: '• Raccomandazioni personalizzate\n• Migliorare l\'app' },
        dataSharing: { title: 'Condivisione', content: 'Non vendiamo i tuoi dati. Condivisione con fornitori (Firebase, Google Gemini) solo se necessario.' },
        aiService: { title: 'Servizio IA (Google Gemini)', content: 'Chefyz usa Google Gemini IA per generare suggerimenti di ricette. I tuoi input vengono inviati ai server di Google e sono soggetti alla privacy policy di Google (https://policies.google.com/privacy).' },
        dataSecurity: { title: 'Sicurezza', content: 'Misure di sicurezza standard.' },
        dataRetention: { title: 'Conservazione e cancellazione dei dati', content: 'Le informazioni dell’account e i contenuti collegati vengono conservati finché l’account è attivo per fornire il servizio. Quando elimini l’account nell’app, l’account Firebase Authentication e i dati dell’app collegabili all’account vengono eliminati definitivamente. Le richieste di cancellazione verificate inviate tramite il sito o via e-mail vengono completate entro 30 giorni. I registri delle richieste IA sono conservati per non più di 24 ore e i registri di utilizzo del dispositivo non collegati all’account, usati per prevenire abusi, per non più di 30 giorni. I dati limitati richiesti per motivi legali o di sicurezza sono conservati solo per il periodo necessario e poi eliminati o anonimizzati.' },
        children: { title: 'Bambini', content: 'Non per minori di 13 anni.' },
        rights: { title: 'I Tuoi Diritti', content: 'Secondo GDPR: accesso, rettifica, cancellazione.' },
        cookies: { title: 'Cookie', content: 'Usiamo cookie.' },
        changes: { title: 'Modifiche', content: 'Possiamo aggiornare questa policy.' },
        contact: { title: 'Contatto', content: 'Contattaci per domande.' }
      }
    },
    terms: {
      title: 'Termini di Servizio', lastUpdated: 'Ultimo aggiornamento',
      intro: 'Usando Chefyz, accetti questi termini.',
      sections: {
        acceptance: { title: 'Accettazione', content: 'Scaricando, accetti questi termini.' },
        service: { title: 'Servizio', content: 'Chefyz è un assistente ricette IA.' },
        account: { title: 'Account', content: 'Sei responsabile del tuo account.' },
        usage: { title: 'Uso', content: 'Nessun uso illegale.' },
        subscription: { title: 'Premium', content: 'Rinnovo automatico.' },
        content: { title: 'Proprietà', content: 'Tutti i contenuti appartengono a Chefyz.' },
        disclaimer: { title: 'Disclaimer', content: 'Ricette solo informative.' },
        termination: { title: 'Terminazione', content: 'Possiamo sospendere il tuo account.' },
        changes: { title: 'Modifiche', content: 'Possiamo cambiare questi termini.' },
        governing: { title: 'Legge', content: 'Legge turca applicabile.' }
      }
    },
    support: {
      title: 'Supporto', subtitle: 'Come possiamo aiutarti?',
      faq: { title: 'FAQ', q1: 'È gratis?', a1: 'Sì, funzioni base gratuite.', q2: 'Come cancello Premium?', a2: 'Via App Store o Google Play.', q3: 'Come elimino i miei dati?', a3: 'Usa il modulo.', q4: 'Quali lingue?', a4: 'TR, EN, DE, FR, ES, IT.' },
      contact: { title: 'Contatto', name: 'Nome', email: 'Email', subject: 'Oggetto', message: 'Messaggio', send: 'Invia', success: 'Inviato!', subjects: { general: 'Generale', bug: 'Bug', feature: 'Suggerimento', account: 'Account', other: 'Altro' } }
    },
    dataDeletion: {
      title: 'Elimina Dati', subtitle: 'Richiedi la cancellazione',
      intro: 'Secondo GDPR, puoi richiedere la cancellazione.',
      process: { title: 'Processo', step1: 'Compila il modulo', step2: 'Elaborazione in 30 giorni', step3: 'Notifica via email' },
      what: { title: 'Dati eliminati', content: '• Account\n• Preferiti\n• Cronologia' },
      form: { email: 'Email registrata', reason: 'Motivo (opzionale)', confirm: 'Capisco che i miei dati saranno eliminati', submit: 'Richiedi', success: 'Richiesta ricevuta.' },
      note: 'La cancellazione è irreversibile.'
    }
  }
};

export const LANGUAGES = [
  { code: 'tr', label: 'Türkçe', flag: '🇹🇷' },
  { code: 'en', label: 'English', flag: '🇬🇧' },
  { code: 'de', label: 'Deutsch', flag: '🇩🇪' },
  { code: 'fr', label: 'Français', flag: '🇫🇷' },
  { code: 'es', label: 'Español', flag: '🇪🇸' },
  { code: 'it', label: 'Italiano', flag: '🇮🇹' }
];
